exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".name[data-v-b1fb5f32]{font-size:14px}.xm-container[data-v-b1fb5f32]{position:relative;width:100%;padding-left:200px}.xm-content[data-v-b1fb5f32]{position:relative;width:920px;margin:62px auto 55px;border-radius:6px;background:#fff}.xm-content.full-width[data-v-b1fb5f32]{width:calc(100% - 32px);min-width:920px;margin:62px 16px 55px}.appointment-container[data-v-b1fb5f32],.export-container[data-v-b1fb5f32]{width:1034px;min-height:583px;background:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}", ""]);

// exports
